import { IconToggleStarOn12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SuperAgentIcon.css';

export const SuperAgentIcon: React.FC = () => {
  return (
    <div className={styles['circle']}>
      <IconToggleStarOn12 color="icon-inverted-default" />
    </div>
  );
};
